import React, { useContext, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { CoursesCtx } from '../../contexts/CoursesContext';
import { ToastCtx } from '../../contexts/ToastContext';
import useRequireLogin from '../../hooks/useRequireLogin';
// My appointments components
import AllCourses from '../../components/customerArea/myAppointments/AllCourses';
import AccountNav from '../../components/customerArea/shared/AccountNav';
import SkeletonCourses from '../../components/customerArea/myAppointments/SkeletonCourses';
// Shared components
import Row from '../../components/shared/atoms/Row';
import Box from '../../components/shared/atoms/Box';
import Container from '../../components/shared/atoms/Container';
import Heading from '../../components/shared/atoms/Heading';
import Button from '../../components/shared/atoms/Button';
import EmptyState from '../../components/shared/molecules/EmptyState';
import AppPromoCard from '../../components/shared/organisms/AppPromoCard';
import { APPLE_ITUNES_APP_META } from '../../utils/appLinks';

function Account() {
  const { t } = useTranslation();
  const client = useSelector((s) => s.client);
  const { courses, loading, getCourses } = useContext(CoursesCtx);
  const { showToast } = useContext(ToastCtx);
  useRequireLogin();

  useEffect(() => {
    // Check if user just confirmed a course
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('confirmed') === 'true') {
      showToast({
        type: 'success.main',
        title: t('course.confirmation.success.title', 'Course confirmée !'),
        description: t(
          'course.confirmation.success.description',
          'Votre course a été confirmée avec succès.',
        ),
      });
      // Clean URL without reloading
      const newUrl = window.location.pathname;
      window.history.replaceState({}, '', newUrl);
    }

    if (client.id) {
      getCourses();
    }
  }, []);

  return (
    <Container>
      <Container fluid pb={10} pt={4}>
        <Helmet
          title={t('account.meta.title')}
          meta={[APPLE_ITUNES_APP_META]}
        />
        <Row md gap={56}>
          <AccountNav />
          <Box mt={{ xs: -7, lg: 0 }}>
            <Heading level={2} mb={{ xs: 4, lg: 6 }}>
              {t('myappointments')}
            </Heading>
            {loading ? (
              <SkeletonCourses />
            ) : (
              <div>
                {!courses.length ? (
                  <Box alignItems="center">
                    <EmptyState
                      width="60%"
                      title={t('account.nocourse.titles.1')}
                      subTitle={t('account.nocourse.subtitles.1')}
                      cta={
                        <Button
                          mt={2}
                          alignSelf="center"
                          to="/reparation"
                          style={{ fontFamily: 'inherit' }}>
                          {t('cta.book')}
                        </Button>
                      }
                    />
                  </Box>
                ) : (
                  <AllCourses courses={courses} />
                )}
                <AppPromoCard placement="compte" mt={6} />
              </div>
            )}
          </Box>
        </Row>
      </Container>
    </Container>
  );
}

export default Account;
